<!--
 * @Author: Q in 
 * @Date: 2026-03-10 12:00:21
 * @LastEditors: Q in 
 * @LastEditTime: 2026-04-02 11:51:23
 * @FilePath: /new_kefu_pc/src/views/index/index.vue
 * @Description: 客服端首页
-->
<template>
    <div id="index">
        首页
    </div>
</template>

<script>
export default {
    data() {
        return {
            
        }
    },

    created() {
        
    },

    destroyed() {
        
    },

    mounted() {
        
    },

    methods: {
        
    },
}
</script>

<style scoped lang='scss'>
#index {
    
}
</style>